<template>
  <Button
      :style="buttonStyle"
      class="p-button-secondary p-mr-2 p-mb-2 non-selectable alarm-view-btn"
      @click="$emit('click', $event)"
  >
    <strong :style="`color:${button.textColor ?? '#ffffff'}!important;`" class="btn-label">
      {{ button['custom-name'] ?? button.alarmName }}
    </strong>
    <i
        :class="`icon_big ${(button.icon && button.icon.name) || 'mdi mdi-alert-outline'}`"
        :style="`color:${button.textColor ?? '#ffffff'}`"
    />
    <img
        v-if="button.existable && !button.hasenddate && button.lastjobid"
        src="assets/layout/images/flag.png"
        class="flag-img"
    />
  </Button>
</template>

<script>
export default {
  name: 'AlarmButtonViewCard',
  props: {
    button: { type: Object, required: true },
    isPointSelected: { type: Boolean, default: false },
    isButtonSelected: { type: Boolean, default: false },
  },
  emits: ['click'],
  computed: {
    buttonStyle() {
      const base = this.button.style ?? ''
      const bg = `background-color:${this.button.bgColor}!important;`
      const pointBorder = this.isPointSelected ? 'border:solid 1px #80b53f;' : ''
      const buttonShadow = this.isButtonSelected ? 'box-shadow:0px 0px 5px 2px rgba(36,36,36,0.7);' : ''
      return `${base}${bg}${pointBorder}${buttonShadow}`
    }
  }
}
</script>
